// Bootstrap JS utilities: Remove it if it's not needed
// -----------------------------------------------------------------------------
import './_bootstrap';

// Polyfill and custom global JS
// -----------------------------------------------------------------------------
import './_polyfill';


(function ($, Drupal) {
    //console.log("main.script.js loaded");

	Drupal.behaviors.bipTooltip = {
		attach: function (context) {
			var $elm = $('[data-toggle="tooltip"]', context);
			
			if(!$elm){
				return false;
			}

			$elm.tooltip({
				trigger: 'hover',
				delay: {show: 150, hide: 0},
			});
		}
	};

	//Event listener to switch brand in header logo
	Drupal.behaviors.switchBrand = {
		attach: function (context) {

			document.addEventListener('switchbrand', function(event){

				let brand = event.detail.brand,
						body = document.querySelector('body'),
						bimClass = 'brand-bim';

				if( brand === 'parking') {
						body.classList.remove(bimClass);
				} else if ( brand === 'charging' || brand === 'sharing' ) {
					body.classList.add(bimClass);
				}
			}, context);
		}
	}

	Drupal.behaviors.checkBrand = {
		attach: function (context) {
				let currentBrand = drupalSettings.brand,
						body = document.querySelector('body');

			if(!currentBrand){
				return false;
			}

			if(currentBrand === 'bim'){
				body.classList.add('brand-bim');
			}else{
				body.classList.remove('brand-bim');
			}

		}
	}

	Drupal.behaviors.hoverSubmenu = {
		attach: function (context){

			let dropdown= document.querySelectorAll('.nav--main .dropdown'),
					media = window.matchMedia('(min-width: 992px) and (hover:hover)'),
					mediaNoHover = window.matchMedia('(hover:none)'),
				backElms = document.querySelectorAll('.nav--main .js-submenu-back');

			if( dropdown && media.matches){
				dropdown.forEach(function(elm){

					elm.addEventListener('mouseenter', function(){
						let menu = this,
							submenu = menu.querySelector('.dropdown-menu'),
							toggle = menu.querySelector('.dropdown-toggle');

						submenu.classList.add('show');

					})

					elm.addEventListener('mouseleave', function(){
						let menu = this,
							submenu = menu.querySelector('.dropdown-menu'),
							toggle = menu.querySelector('.dropdown-toggle');

						submenu.classList.remove('show');
					})


					elm.addEventListener('click', function (e) {
						e.stopPropagation()
					})
				})

			} else if ( dropdown && mediaNoHover.matches || dropdown && !media.matches) {
				dropdown.forEach(function (elm) {

					let dropdownToggle = elm.querySelector('.dropdown-toggle.sub-trigger');

					if(dropdownToggle) {

						dropdownToggle.addEventListener('click', function (e) {
							let menu = this,
								submenu = menu.nextElementSibling,
								navItem = menu.parentNode;

							if ( submenu.classList.contains('show') ) {
								submenu.classList.remove('show');
								navItem.classList.remove('show');
								e.stopPropagation();
							} else {
								submenu.classList.add('show');
								e.stopPropagation();
							}

						});
					}



				});

				backElms.forEach(function(backElm){
					backElm.addEventListener('click',function(e){
						let obj = this,
							submenu = obj.closest('.dropdown-menu.show');

						submenu.classList.remove('show');
						e.stopPropagation();
					})
				})
			}

		}
	}

	Drupal.behaviors.subMenuLvlTwo = {
		attach: function (context){
			let elm= document.querySelectorAll('.nav--main .js-submenu-lvl-two'),
					backElm = document.querySelectorAll('.nav--main .js-submenu-lvl-two-back');

			if(!elm){
				return false;
			}

			elm.forEach(function(elm){
				elm.addEventListener('click' , function(elm){
				  let obj = this,
					    submenu = obj.parentElement.querySelector('.dropdown-submenu-lvl-2');

					elm.preventDefault();

					if( submenu.classList.contains('show') ) {
						submenu.classList.remove('show');
					} else {
						obj.closest('.dropdown-submenu').querySelectorAll('.dropdown-submenu-lvl-2').forEach(function(i) {
							i.classList.remove('show');
						})
						submenu.classList.add('show');
					}
				})
			})

			backElm.forEach(function(backElm){
					backElm.addEventListener('click',function(elm){
						let obj = this,
						submenu = obj.closest('.dropdown-submenu-lvl-2.show');

						submenu.classList.remove('show');
						elm.stopPropagation();
					})
			})

		}
	}

})(jQuery, Drupal);


